import { render, staticRenderFns } from "./error-message.vue?vue&type=template&id=35530443&scoped=true"
import script from "./error-message.vue?vue&type=script&lang=js"
export * from "./error-message.vue?vue&type=script&lang=js"
import style0 from "./error-message.vue?vue&type=style&index=0&id=35530443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35530443",
  null
  
)

export default component.exports